/* import PropertiesReader from 'properties-reader';
var properties = PropertiesReader('../../../../resources/errors.properties');

export const ACTION_INVALID = "This action is invalid!"

export const property = properties.get('some.property.name'); */

export const OK = "#C3FFBC";
export const NOT_OK = "#FFC1C1";
export const WARNING = "#FFB070";
export const MAIN_COLOR = "#003366"; //FINA-ina plava
export const MAIN_COLOR2 = "#004D99"; //FINA-ina plava v2
export const MAIN_COLOR5 = "#E0E0E0";//FINA-ina siva
export const MAIN_COLOR3 = "#0066CC"; //FINA-ina plava v3
export const MAIN_COLOR4 = "#C6C6C6"; //tamnija siva
export const MAIN_COLOR6 = "#E6F2FF"; //FINA-ina najsvjetlija plava
export const GREEN = "#008a00"; //zelena
export const RED = "#de0000"; //crvena
export const ORANGE = "#b95900"; //narančasta
export const WHITE = "#FFF"; //bijela